/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesListServiceLogs } from "../../funcs/computeServicesListServiceLogs.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServiceLogsRequest$inboundSchema,
};

export const tool$computeServicesListServiceLogs: ToolDefinition<typeof args> =
  {
    name: "compute-services-list-service-logs",
    description: `List service logs`,
    args,
    tool: async (client, args, ctx) => {
      const [result, apiCall] = await computeServicesListServiceLogs(
        client,
        args.request,
        { fetchOptions: { signal: ctx.signal } },
      ).$inspect();

      if (!result.ok) {
        return {
          content: [{ type: "text", text: result.error.message }],
          isError: true,
        };
      }

      const value = result.value;

      return formatResult(value, apiCall);
    },
  };
